import StateView from './view/StateView';
import config from './config/config';
import GConfig from '../../config/config';

/**
 * initialize the components with states.
 * @param {editor} em
 * @param {states array stored in db} states
 */
function initialize(em, states) {
  if (states) {
    if (typeof states == 'string') {
      states = JSON.parse(states);
    }
    for (var blockName in states) {
      var statesObj = states[blockName]; // states of each block
      var statesCollection = [];
      var blockID = '';
      for (var state in statesObj) {
        var className = statesObj[state].className;
        blockID = statesObj[state].selector;
        if (config.defaultstates.indexOf(state) == -1) {
          var obj = {
            id: className,
            name: state,
            className: className
          };
          statesCollection.push(obj);
        }
      }
      em.Config.blockWithStates.push(blockID);
      statesCollection = config.states.concat(statesCollection);
      var component = em.DomComponents.componentsById[blockID];
      component.set('statesCollection', statesCollection);
      component.set('blockName', blockName);
    }
  }
}

/**
 * return the state view object to append in style manager view.
 * @param {editor} em
 */
function getStateView(em) {
  var stateView = new StateView({ em: em, GConfig: GConfig });
  return stateView.render();
}

/**
 * returns the state json for get studio state
 * @param {Editor object} em
 * */
function getStudioStateJSON(em) {
  return getJson(em, em.Config.blockWithStates);
}

/**
 * get states json
 * @param {editor} em
 * @param {array of blockid which has states} componentsid
 */
function getJson(em, componentsid) {
  var StudioStates = {};
  componentsid.forEach(function(block_id) {
    var component = em.DomComponents.componentsById[block_id];
    if (component) {
      var states = component.get('statesCollection').filter(function(state) {
        return state.id != '';
      });
      var obj = {};
      var block_name = component.get('blockName') || component.getId();
      states.forEach(
        function(state) {
          this.obj[state.name] = {
            className: state.className,
            selector: this.component.getId()
          };
        },
        { component, obj }
      );
      StudioStates[block_name] = obj;
    }
  });
  return StudioStates;
}

export default {
  init: initialize,
  getStateView: getStateView,
  stateJson: getStudioStateJSON
};
